/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import axios from "axios";
import Vue from "vue";
import Cookies from 'js-cookie'

const ENDPOINT = `${Vue.prototype.API_ENDPOINT}/graphql`;
let XAUTHORIZATION = null;

axios.interceptors.request.use(
  (_config) => {
    const config = _config;

    if (config.url.indexOf("graphql") !== -1 && !config.url.includes(Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT)) {
      const params = new URLSearchParams();
      let query = config.data.get("query");
      let variables = config.data.get("variables");

      // Se xauthorization NAO puder ser um número, então ele é um token que vai ser passado no header
      // user_id passa a ser zero pois as queries precisam ser integer
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(XAUTHORIZATION)) {
        query = query.replace(
          /(user[_]?id:\s?)(['"]?)([a-zA-Z0-9=]+)(['"]?)/gi,
          "$1$20$4"
        );

        const userIdDecriptedByCurrentToken = Vue.prototype.$encrypts.decrypt(
          XAUTHORIZATION,
          config.headers.Authorization
        );
        const userIdDecriptedByPrimaryToken = Vue.prototype.$encrypts.decrypt(
          XAUTHORIZATION,
          process.env.VUE_APP_API_TOKEN
        );
        const userIdDecriptedBySecondaryToken = Vue.prototype.$encrypts.decrypt(
          XAUTHORIZATION,
          process.env.VUE_APP_API_TOKEN_2
        );
        const userIdDecriptedByTertiaryToken = Vue.prototype.$encrypts.decrypt(
          XAUTHORIZATION,
          process.env.VUE_APP_API_TOKEN_3
        );

        config.headers["X-Authorization"] = `Basic ${Vue.prototype.$encrypts.encrypt(userIdDecriptedByCurrentToken, config.headers.Authorization)}`;

        if (userIdDecriptedByPrimaryToken.length > 0 && !isNaN(userIdDecriptedByPrimaryToken)) {
          // Se o decript aconteceu usando o token primário, então setamos o token primário como o token oficial da request
          config.headers.Authorization = `Token token=${process.env.VUE_APP_API_TOKEN}`;
          config.headers["X-Authorization"] = `Basic ${Vue.prototype.$encrypts.encrypt(userIdDecriptedByPrimaryToken, config.headers.Authorization)}`;
        } else if (userIdDecriptedBySecondaryToken.length > 0 && !isNaN(userIdDecriptedBySecondaryToken)) {
          // Se o decript aconteceu usando o token secundário, então setamos o token secundário como o token oficial da request
          config.headers.Authorization = `Token token=${process.env.VUE_APP_API_TOKEN_2}`;
          config.headers["X-Authorization"] = `Basic ${Vue.prototype.$encrypts.encrypt(userIdDecriptedBySecondaryToken, config.headers.Authorization)}`;
        } else if (userIdDecriptedByTertiaryToken.length > 0 && !isNaN(userIdDecriptedByTertiaryToken)) {
          // Se o decript aconteceu usando o token terciário, então setamos o token terciário como o token oficial da request
          config.headers.Authorization = `Token token=${process.env.VUE_APP_API_TOKEN_3}`;
          config.headers["X-Authorization"] = `Basic ${Vue.prototype.$encrypts.encrypt(userIdDecriptedByTertiaryToken, config.headers.Authorization)}`;
        }
      }

      query = Vue.prototype.$encrypts.encrypt(
        query,
        config.headers.Authorization
      );
      params.append("query", query);

      if (variables && variables.length > 0) {
        variables = Vue.prototype.$encrypts.encrypt(
          variables,
          config.headers.Authorization
        );
        params.append("variables", variables);
      }

      config.data = params;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    if (response.config.url.indexOf("graphql") !== -1 && !response.config.url.includes(Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT)) {
      if (response.data && !response.data.error) {
        response.data.data = Vue.prototype.$encrypts.decrypt(
          response.data.data,
          response.config.headers.Authorization
        );
        response.data.data = JSON.parse(response.data.data);
      }
    }

    return response;
  },
  (_error) => {
    const error = _error;
    if (error.response && error.response.data && error.response.data.message) {
      error.response.data.message = Vue.prototype.$encrypts.decrypt(
        error.response.data.message,
        error.response.config.headers.Authorization
      );
    }

    return Promise.reject(error);
  }
);

export default {
  namespaced: true,

  state: {
    isAuth: false,
    nextRoute: JSON.parse(localStorage.getItem("nextRoute")) || "",
    avatar: null,
    profile: null,
    follower: false,
    termsOfUseAccepted: false,
    profileExternalBase: null,
    formStruct: {
      acknowledgments: { fields: [] },
      address: { fields: [] },
      diversity: { fields: [] },
      education: { fields: [] },
      extracurricular_experience: { fields: [] },
      languages: { fields: [] },
      personal_data: { fields: [] },
      professional_experience: { fields: [] },
      skills: { fields: [] },
    },
  },

  mutations: {
    SET_AUTH(_state, payload) {
      const state = _state;
      state.isAuth = payload;
    },

    SET_NEXT_ROUTE(_state, payload) {
      const state = _state;
      state.nextRoute = payload;
      localStorage.setItem("nextRoute", JSON.stringify(payload));
    },

    SET_AVATAR(_state, payload) {
      const state = _state;
      state.avatar = payload;
    },

    SET_PROFILE(_state, payload) {
      const state = _state;
      const { profile } = state;

      if (profile && payload) {
        Object.keys(payload).forEach((key) => {
          profile[key] = payload[key];
        });
      }

      state.profile =
        profile != null ? { ...state.profile, ...profile } : payload;
    },

    SET_MEDICALREPORTS(_state, payload) {
      const state = _state;
      state.profile.medicalReports = payload;
    },

    SET_FOLLOWER(_state, payload) {
      const state = _state;
      state.follower = payload;
      localStorage.setItem("follower", payload);
    },

    SET_TERMS_OF_USE_ACCEPTED(_state, payload) {
      const state = _state;
      state.termsOfUseAccepted = payload;
      localStorage.setItem("termsOfUseAccepted", payload);
    },

    SET_PROFILE_EXTERNAL_BASE(_state, payload) {
      const state = _state;
      const profile = payload;
      if (!profile.disabilities) profile.disabilities = [];
      if (!profile.language_proficiencies) profile.language_proficiencies = [];
      if (!profile.educations) profile.educations = [];
      if (!profile.professional_experiences)
        profile.professional_experiences = [];

      if (!profile.location) {
        profile.location = {
          zipcode: payload.location_zipcode,
          street: payload.location_street,
          number: payload.location_number,
          complement: payload.location_complement,
          neighborhood: payload.location_neighborhood,
          stateId: payload.location_state_id,
          city: payload.location_city,
        };
      }

      if (!profile.firstname) {
        const fullname = profile.name.split(" ");
        const firstname = fullname[0];
        const lastname = fullname.slice(1, fullname.length).join(" ");

        profile.firstname = firstname;
        profile.lastname = lastname;
      }

      state.profileExternalBase = payload;
    },

    SET_FORMSTRUCT(_state, payload) {
      const state = _state;

      if(payload == 'reset'){
        payload = {
          acknowledgments: { fields: [] },
          address: { fields: [] },
          diversity: { fields: [] },
          education: { fields: [] },
          extracurricular_experience: { fields: [] },
          languages: { fields: [] },
          personal_data: { fields: [] },
          professional_experience: { fields: [] },
          skills: { fields: [] },
        }
      }

      state.formStruct = payload;
    },
  },

  getters: {},

  actions: {
    checkAuth({ commit, dispatch }) {
      if (localStorage.getItem("devise")) {
        const devise = JSON.parse(
          decodeURIComponent(escape(atob(localStorage.getItem("devise"))))
        );
        const now = new Date().getTime() / 1000;
        XAUTHORIZATION = devise.profile.id;

        // Se o timestamp atual for menor que o limite estabelecido na variável loggedInUntil, então logamos
        // Senão, forçamos o logout
        if (devise.keepLogged) {
          if (now < devise.loggedInUntil) {
            Vue.prototype.$session.renew(devise.id);
          } else {
            dispatch("signOut");
          }
        }

        if (Vue.prototype.$session.exists()) {
          commit("SET_AUTH", true);
          commit("SET_PROFILE", devise.profile);
          dispatch("companyFollow");
          return { logged: true };
        }
        dispatch("signOut");
        return { logged: false };
      }
      dispatch("signOut");
      return { logged: false };
    },

    signOut({ commit }) {
      commit("SET_AUTH", false);
      commit("SET_PROFILE", null);
      commit("opportunities/SET_SUBSCRIPTIONS", [], { root: true });
      localStorage.removeItem("devise");
      localStorage.removeItem("follower");
      localStorage.removeItem("termsOfUseAccepted");
      localStorage.removeItem("nextRoute");
      Vue.prototype.$session.destroy();
    },

    linkedinProfile({ rootState }, obj = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${Vue.prototype.API_ENDPOINT}/linkedin/token?redirect_uri=${obj.return_url}&code=${obj.code}&company=${obj.company}`,
            { headers: { Authorization: rootState.tkn } }
          )
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    isEmployer({ rootState }, obj = {}) {
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          isEmployer(
            ${obj.email ? ` email: "${obj.email.toLowerCase()}" ,` : ""}
            ${obj.document ? ` document: "${obj.document}" ,` : ""}
            ${obj.unique_id ? ` unique_id: "${obj.unique_id}" ,` : ""}
            ${obj.user_id ? ` user_id: ${obj.user_id} ,` : ""}
            company_id: ${obj.companyId || rootState.companyId}
          )
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(`${Vue.prototype.API_ENDPOINT}/graphql`, params, {
            headers: { Authorization: rootState.tkn },
          })
          .then(
            (resp) => {
              const isEmployer = resp.data;
              resolve(isEmployer);
            },
            (error) => {
              reject(error);
            }
          )
          .catch((error) => {
            reject(error);
          });
      });
    },

    employerSignIn({ dispatch, rootState }, obj = {}) {
      const params = new URLSearchParams();
      let query = "";
      let variables = "";
      const data = `
      {
        ${obj.returns || "id, name, termsOfUserAccepted{ companyId }"}
      }
      `;

      query = `
        mutation {
          employerSignIn(
            ${obj.email ? ` email: "${obj.email.toLowerCase()}" ,` : ""}
            ${obj.document ? ` document: "${obj.document}" ,` : ""}
            ${obj.unique_id ? ` unique_id: "${obj.unique_id}" ,` : ""}
            password: "${window.btoa(obj.password)}",
            company_id: ${obj.companyId || rootState.companyId},
          )
          ${data}
        }
      `;

      variables = JSON.stringify({ encrypt_user_id: true });
      params.append("query", query);
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (!response.error) {
                const user = response.data.employerSignIn;
                dispatch("auth", {
                  user,
                  keepLogged: obj.keepLogged,
                  hoursLogged: obj.hoursLogged,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    signIn({ dispatch, rootState }, obj = {}) {
      const params = new URLSearchParams();
      let query = "";
      let variables = "";
      const data = `
      {
        ${obj.returns || "id, name, email, termsOfUserAccepted{ companyId }, profile { socialName }"}
      }
      `;

      if (obj.provider) {
        if (obj.provider == "99jobs" && obj.forceUser) {
          XAUTHORIZATION = obj.forceUser;

          query = `
            query {
              user(
                id: "${obj.forceUser}"
              )
              ${data}
            }
          `;
        } else if (obj.provider == "itau") {
          query = `
            mutation {
              itauLogin(
                code: "${obj.code}",
                development: ${obj.development},
                ${
                  obj.source
                    ? ` login_source: "${obj.source}" `
                    : rootState.source
                    ? ` login_source: "${rootState.source}" `
                    : ""
                }
              )
              ${data}
            }
          `;
        } else if (obj.provider == "azure") {
          query = `
            mutation {
              microsoftGraphLogin(
                access_token: "${obj.access_token}",
                uid: "${obj.uid}",
                user_name: "${obj.user_name}",
                user_email: "${obj.user_email}"
              )
              ${data}
            }
          `;
        } else if (obj.provider == "magalu") {
          query = `
          mutation {
            magazineLuizaLogin(
              login: "${obj.unique_id}",
              password: "${obj.password}",
            )
            ${data}
          }`;
        } else {
          query = `
            mutation {
              socialMediaLogin(
                provider: "${obj.provider}",
                provider_id: "${obj.provider_id}",
                origin_company: ${obj.companyId || rootState.companyId}
              )
              ${data}
            }
          `;
        }
      } else {
        query = `
          mutation {
            userLogin(
              email: "${obj.username || obj.email.toLowerCase()}",
              password: "${window.btoa(obj.password)}",
              origin_company: ${obj.companyId || rootState.companyId}
            )
            ${data}
          }
        `;
      }

      variables = JSON.stringify({ encrypt_user_id: true });
      params.append("query", query);
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (!response.error) {
                const user =
                  response.data.userLogin ||
                  response.data.socialMediaLogin ||
                  response.data.itauLogin ||
                  response.data.microsoftGraphLogin ||
                  response.data.magazineLuizaLogin ||
                  response.data.user;

                if (obj.provider == "99jobs" && obj.forceUser) {
                  user["99jobs"] = true;
                }

                dispatch("auth", {
                  user,
                  keepLogged: obj.keepLogged,
                  hoursLogged: obj.hoursLogged,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    employerSignUp({ dispatch, rootState }, obj = {}) {
      const params = new URLSearchParams();
      const data = `
      {
        id,
        name,
        profile{ id }
      }
      `;

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      params.append(
        "query",
        `
        mutation {
          employerSignUp(
            name: "${obj.first_name} ${obj.last_name}",
            ${obj.email ? ` email: "${obj.email.toLowerCase()}" ,` : ""}
            ${obj.document ? ` document: "${obj.document}" ,` : ""}
            ${obj.unique_id ? ` unique_id: "${obj.unique_id}" ,` : ""}
            password: "${window.btoa(obj.password)}",
            company_id: ${obj.companyId || rootState.companyId},
          )
          ${data}
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const employerSignUp = resp.data;

              if (!employerSignUp.error) {
                const user = employerSignUp.data.employerSignUp;
                dispatch("auth", { user, keepLogged: false });
              }

              resolve(employerSignUp);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    signUp({ dispatch, rootState }, obj = {}) {
      const params = new URLSearchParams();
      const data = `
      {
        id,
        name,
        profile{ id }
      }
      `;

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      params.append(
        "query",
        `
        mutation {
          userCreate(
            name: "${obj.first_name} ${obj.last_name}",
            firstname: "${obj.first_name}",
            lastname: "${obj.last_name}",
            email: "${obj.email.toLowerCase()}",
            foreigner: ${obj.foreigner},
            document: "${obj.document}",
            ${obj.phone ? ` phone: "${obj.phone}" ,` : ""}
            ${obj.password ? ` password: "${window.btoa(obj.password)}" ,` : ""}
            origin_company: ${obj.companyId || rootState.companyId},
            ${obj.provider ? ` provider: "${obj.provider}" ,` : ""}
            ${obj.provider ? ` provider_id: "${obj.provider_id}" ,` : ""}
            ${
              obj.accept_terms_of_use
                ? ` accept_terms_of_use: ${obj.accept_terms_of_use} ,`
                : ""
            }
            ${
              obj.accept_terms_of_use
                ? ` source: ${
                    obj.source ? `"${obj.source}"` : `"${rootState.source}"`
                  } ,`
                : ""
            }
          )
          ${data}
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const signUpResponse = resp.data;

              if (!signUpResponse.error) {
                const user = signUpResponse.data.userCreate;
                dispatch("auth", { user, keepLogged: false });
              }

              resolve(signUpResponse);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    auth({ commit, rootState }, obj = {}) {
      const keepLogged = obj.keepLogged || false;
      const hoursLogged = obj.hoursLogged || 24;
      const profile = obj.user;

      Vue.prototype.$session.start();

      localStorage.setItem(
        "devise",
        btoa(
          unescape(
            encodeURIComponent(
              JSON.stringify({
                id: Vue.prototype.$session.id(),
                loggedInUntil: keepLogged
                  ? Math.floor(
                      new Date(
                        new Date().getTime() + 60 * 60 * hoursLogged * 1000
                      ) / 1000
                    )
                  : null,
                keepLogged,
                profile,
              })
            )
          )
        )
      );

      commit("SET_AUTH", true);
      commit("SET_PROFILE", profile);
      commit(
        "SET_TERMS_OF_USE_ACCEPTED",
        (profile &&
          profile.termsOfUserAccepted &&
          profile.termsOfUserAccepted.find(
            (terms) => terms.companyId == rootState.companyId
          )) != null
      );
      XAUTHORIZATION = profile.id;
    },

    passwordRecovery({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          passwordRecovery(
            email: "${obj.email.toLowerCase()}",
            domain: "${obj.domain}",
            ${obj.companyId ? ` origin_company: ${obj.companyId}` : ""}
          )
          {
            email
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const passwordRecoveryResponse = resp.data;

              resolve(passwordRecoveryResponse);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    changePassword({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          changePassword(
            password: "${window.btoa(obj.password)}",
            ${obj.token ? ` token: "${obj.token}" ,` : ""}
            ${obj.user_id ? ` user_id: ${obj.user_id} ,` : ""}
          )
          {
            email
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const changePasswordResponse = resp.data;

              resolve(changePasswordResponse);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    decryptTokenHunting({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        query {
          decryptTokenHunting(
            token: "${obj.token}"
          )
          {
            valid, user { id, forceChangePassword, email }, opportunity { id }
          }
        }
      `
      );

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const decryptTokenHunting = resp.data;
              resolve(decryptTokenHunting);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    acceptHunting({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          acceptHunting(
            token: "${obj.token}"
          )
          {
            id
          }
        }
      `
      );

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const acceptHunting = resp.data;
              resolve(acceptHunting);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    refuseHunting({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          refuseHunting(
            token: "${obj.token}"
          )
          {
            id
            forceChangePassword
            email
            name
          }
        }
      `
      );

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const refuseHunting = resp.data;
              resolve(refuseHunting);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    updateHunting({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          updateHunting(
            token:"${obj.token}",
            document: "${obj.document}",
            foreigner: ${obj.foreigner}
          )
          {
            id
            hasUser
            hasMoreRegister
          }
        }
      `
      );

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const updateHunting = resp.data;
              resolve(updateHunting);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    personalDataUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();

      params.append(
        "query",
        `
        mutation {
          personalDataUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${
              obj.firstname && obj.lastname
                ? ` name: "${obj.firstname} ${obj.lastname}" ,`
                : ""
            }
            ${obj.email !== undefined && obj.email !== null ? ` email: "${obj.email}" ,` : ""}
            ${obj.firstname !== undefined && obj.firstname !== null ? ` firstname: "${obj.firstname}" ,` : ""}
            ${obj.lastname !== undefined && obj.lastname !== null ? ` lastname: "${obj.lastname}" ,` : ""}
            ${obj.cpf !== undefined && obj.cpf !== null ? ` cpf: "${obj.cpf}" ,` : ""}
            ${obj.passport !== undefined && obj.passport !== null ? ` passport: "${obj.passport}" ,` : ""}
            ${obj.birthday !== undefined && obj.birthday !== null ? ` birthday: "${obj.birthday}" ,` : ""}
            ${obj.phone !== undefined && obj.phone !== null ? ` phone: "${obj.phone}" ,` : ""}
            ${obj.nationality !== undefined && obj.nationality !== null ? ` nationality: "${obj.nationality}" ,` : ""}
            ${obj.gender !== undefined && obj.gender !== null ? ` gender: ${obj.gender} ,` : ""}
            ${
              obj.marital_status !== undefined && obj.marital_status !== null
                ? ` marital_status: ${obj.marital_status}`
                : obj.maritalStatus !== undefined && obj.maritalStatus !== null
                ? ` marital_status: ${obj.maritalStatus}`
                : ""
            }
            ${
              obj.whatDoYouLove !== undefined && obj.whatDoYouLove !== null
                ? ` what_do_you_love: "${obj.whatDoYouLove}" ,`
                : ""
            }
            address: {
              ${obj.street !== undefined && obj.street !== null ? ` street: "${obj.street}" ,` : ""}
              ${obj.number !== undefined && obj.number !== null ? ` number: "${obj.number}" ,` : ""}
              ${obj.complement !== undefined && obj.complement !== null ? ` complement: "${obj.complement}" ,` : ""}
              ${
                obj.neighborhood !== undefined && obj.neighborhood !== null ? ` neighborhood: "${obj.neighborhood}" ,` : ""
              }
              ${obj.zipcode !== undefined && obj.zipcode !== null ? ` zipcode: "${obj.zipcode}" ,` : ""}
              ${obj.city !== undefined && obj.city !== null ? ` city: "${obj.city}" ,` : ""}
              ${obj.state !== undefined && obj.state !== null ? ` state: "${obj.state}" ,` : ""}
            }
            ${
              obj.hasOwnProperty("has_disability")
                ? ` has_disability: ${obj.has_disability} ,`
                : ""
            }
            ${obj.disabilities !== undefined && obj.disabilities !== null ? ` disabilities: [${obj.disabilities}] ,` : ""}
            ${obj.socialName !== undefined && obj.socialName !== null ? ` social_name: "${obj.socialName}" ,` : ""}
            ${
              obj.raceAndEthnicity !== undefined && obj.raceAndEthnicity !== null
                ? ` race_and_ethnicity: "${obj.raceAndEthnicity}" ,`
                : ""
            }
            ${obj.familyIncome !== undefined && obj.familyIncome !== null ? ` family_income: "${obj.familyIncome}" ,` : ""}
            ${
              obj.personalIncome !== undefined && obj.personalIncome !== null
                ? ` personal_income: "${obj.personalIncome}" ,`
                : ""
            }
            ${obj.pronoun !== undefined && obj.pronoun !== null ? ` pronoun: "${obj.pronoun}" ,` : ""}
            ${
              obj.sexualOrientation !== undefined && obj.sexualOrientation !== null
                ? ` sexual_orientation: "${obj.sexualOrientation}" ,`
                : ""
            }
            ${
              obj.need_help_selection_process !== undefined && obj.need_help_selection_process !== null
                ? ` need_help_selection_process: ${obj.need_help_selection_process} ,`
                : ""
            }
            ${
              obj.description_help_selection_process !== undefined && obj.description_help_selection_process !== null
                ? ` description_help_selection_process: "${obj.description_help_selection_process}" ,`
                : ""
            }

          )
          {
            email
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    uploadUserAvatar({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          uploadUserAvatar(
            user_id: ${rootState.user.profile.id},
            image_base64: "${obj.image}"
          )
          {
            ${obj.return || "avatar"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              if (response.data && response.data.uploadUserAvatar.avatar) {
                commit("SET_AVATAR", response.data.uploadUserAvatar.avatar);
              }

              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    educationCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          educationCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${obj.education_id ? ` education_id: "${obj.education_id}" ` : ""}
            level: "${obj.level}"
            country: "${obj.country}"
            state: "${obj.state}"
            institution: "${obj.institution}"
            ${obj.course ? ` course: "${obj.course}" ` : ""}
            ${obj.campus ? ` campus: "${obj.campus}" ` : ""}
            start_date: "${obj.start_date}"
            end_date: "${obj.end_date}"
            ${obj.period ? ` period: "${obj.period}" ` : ""}
            status: "${obj.status}"
          )
          {
            ${obj.return || "id"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    educationDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          educationDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            education_id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.educationDelete.success) {
                const currentDatas = rootState.user.profile.educations;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", { educations: datasWithoutDeleted });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    professionalExpCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          professionalExpCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${
              obj.professional_experience_id
                ? ` professional_experience_id: "${obj.professional_experience_id}" `
                : ""
            }
            company: "${obj.company}"
            responsabilities: "${obj.responsabilities}"
            occupations: [{
              role: "${obj.role}"
              startYear: "${obj.startYear}"
              endYear: "${obj.endYear}"
              area: "${obj.area}"
              level: "${obj.level}"
              currentOccupation: "${obj.currentOccupation}"
            }]
          )
          {
            ${obj.return || "company"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    professionalExpDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          professionalExpDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            professional_experience_id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.professionalExpDelete.success) {
                const currentDatas =
                  rootState.user.profile.professionalExperiences;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", {
                  professionalExperiences: datasWithoutDeleted,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    causeExpCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          causeExpCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${
              obj.cause_experience_id
                ? ` cause_experience_id: "${obj.cause_experience_id}" `
                : ""
            }
            organization: "${obj.organization}"
            area: "${obj.area}"
            start_date: "${obj.start_date}"
            end_date: "${obj.end_date}"
            country: "${obj.country}",
            responsabilities: "${obj.responsabilities}",
          )
          {
            ${obj.return || "organization"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    causeExpDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          causeExpDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            cause_experience_id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.causeExpDelete.success) {
                const currentDatas = rootState.user.profile.causeExperiences;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", {
                  causeExperiences: datasWithoutDeleted,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    languageCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          languageCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${
              obj.language_proficiency_id
                ? ` language_proficiency_id: "${obj.language_proficiency_id}" `
                : ""
            }
            language: "${obj.language}"
            proficiency: "${obj.proficiency}"
          )
          {
            ${obj.return || "language"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    languageDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          languageDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            language_proficiency_id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.languageDelete.success) {
                const currentDatas =
                  rootState.user.profile.languageProficiencies;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", {
                  languageProficiencies: datasWithoutDeleted,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    acknowledgementCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          acknowledgementCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${
              obj.acknowledgement_id
                ? ` acknowledgement_id: "${obj.acknowledgement_id}" `
                : ""
            }
            description: "${obj.description}"
            title: "${obj.title}"
            date: "${obj.date}"
          )
          {
            ${obj.return || "title"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    acknowledgementDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          acknowledgementDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            acknowledgement_id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.acknowledgementDelete.success) {
                const currentDatas = rootState.user.profile.acknowledgements;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", {
                  acknowledgements: datasWithoutDeleted,
                });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    // eslint-disable-next-line no-empty-pattern
    certificationCreateUpdate({ rootState }, _obj) {
      const obj = Vue.prototype.$helpers.removeSomeCaracters(_obj);
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          certificationCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            ${obj.id ? ` id: "${obj.id}" ` : ""}
            code: "${obj.code}"
            description: "${obj.description}"
            expires_at: "${obj.expires_at}"
          )
          {
            ${obj.return || "description"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    certificationDelete({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          certificationDelete(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            id: "${obj.id}"
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              if (response.data.certificationDelete.success) {
                const currentDatas = rootState.user.profile.certifications;
                const datasWithoutDeleted = currentDatas.filter(
                  (data) => data.id !== obj.id
                );

                commit("SET_PROFILE", { certifications: datasWithoutDeleted });
              }

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    skillsCreateUpdate({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          skillsCreateUpdate(
            user_id: ${rootState.user.profile.id},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
            skills: [${obj.skills.map((i) => `"${i}"`)}]
          )
          {
            ${obj.return || "success"}
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              resolve(resp.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    // Segue a empresa
    followCompany({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          followCompany(
            user_id: ${rootState.user.profile.id},
            company_id: ${obj.companyId || rootState.companyId}
          )
          { success }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              commit("SET_FOLLOWER", response.data.followCompany.success);

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    // Valida se o usuário já é seguidor da empresa
    companyFollow({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      const isFollower = localStorage.getItem("follower");
      if (isFollower) {
        commit("SET_FOLLOWER", isFollower);
        return;
      }

      params.append(
        "query",
        `
        query {
          companyFollow(userId: ${rootState.user.profile.id}, companyId: ${obj.companyId || rootState.companyId}) {
            id,
            userId,
            companyId
          }
        }
      `
      );

      const variables = JSON.stringify({ encrypt_user_id: true });
      params.append("variables", variables);

      // eslint-disable-next-line consistent-return
      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              commit("SET_FOLLOWER", response.data.companyFollow.length > 0);

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    acceptTermsOfUse({ commit, rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          acceptTermsOfUse(
            user_id: ${rootState.user.profile.id},
            company_id: ${obj.companyId || rootState.companyId},
            ${
              obj.source
                ? ` source: "${obj.source}" `
                : rootState.source
                ? ` source: "${rootState.source}" `
                : ""
            }
          )
          { success }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              commit(
                "SET_TERMS_OF_USE_ACCEPTED",
                response.data.acceptTermsOfUse.success
              );

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    forgotUser({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      const key = obj.cpf ? "cpf" : "passport";
      const value = obj.cpf ? obj.cpf : obj.passport;

      params.append(
        "query",
        `
        query {
          users(${key}: "${value}") {
            email
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    removeUser({ rootState }) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          removeUser(
            user_id: ${rootState.user.profile.id},
          )
          { success }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    generateTokenChangeEmail({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          generateTokenChangeEmail(
            user_id: ${obj.id},
          )
          {
            generateToken
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    profileExternalBase({ rootState, commit }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          profileExternalBase(
            token: "${obj.token}"
          )
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const { profileExternalBase } = resp.data.data;

              if (!profileExternalBase.error) {
                commit("SET_PROFILE_EXTERNAL_BASE", profileExternalBase);
              }

              resolve(profileExternalBase);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    validTokenEmail({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        {
          validTokenEmail(
            userId: "${obj.id}",
            token:  "${obj.token}"
          )
          {
            valid
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    integrateProfileExternalBase({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          integrateProfileExternalBase(
            user_id: ${rootState.user.profile.id},
            email: "${obj.email}",
            ${obj.cpf ? ` cpf: "${obj.cpf}" ` : ""}
            ${obj.passport ? ` passport: "${obj.passport}" ` : ""}
          )
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const { integrateProfileExternalBase } = resp.data.data;

              resolve(integrateProfileExternalBase);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    conversionRDStationMagalu({ dispatch, rootState }, obj = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        if (!rootState.user.profile) {
          resolve();
          return;
        }

        await dispatch(
          "graphql_queries/query",
          `user( id: "${rootState.user.profile.id}" ){
          profile{
            email,
            location { stateId, city }
          }
        }`,
          { root: true }
        );

        const payload = {
          conversion_identifier: obj.conversion_identifier,
          email: rootState.user.profile.email,
        };

        if (rootState.user.profile.name) {
          payload.name = rootState.user.profile.name;
        }

        if (
          rootState.user.profile.location &&
          rootState.user.profile.location.stateId &&
          rootState.domains.states.find(
            (st) => st.id == rootState.user.profile.location.stateId
          )
        ) {
          payload.state = rootState.domains.states.find(
            (st) => st.id == rootState.user.profile.location.stateId
          ).abbr;
        }

        if (
          rootState.user.profile.location &&
          rootState.user.profile.location.city
        ) {
          payload.city = rootState.user.profile.location.city;
        }

        axios
          .post(
            "https://api.rd.services/platform/conversions?api_key=d9c26098af26e3f62983bb7227d0fb34",
            {
              event_type: "CONVERSION",
              event_family: "CDP",
              payload,
            }
          )
          .then((resp) => {
            resolve(resp);
          });
      });
    },

    changeEmail({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          changeEmail(
            user_id: ${obj.id},
            token:  ${obj.token},
            email:  "${obj.email}",
          )
          {
            email
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    validateMagazineLuizaEmployees({ rootState }, obj = {}) {
      const checkMlContributor = localStorage.getItem("mlContributor");
      const checkMlContributorDate = localStorage.getItem("mlContributorDate");

      const isToday = (someDate) => {
        const today = new Date();
        return (
          someDate.getDate() == today.getDate() &&
          someDate.getMonth() == today.getMonth() &&
          someDate.getFullYear() == today.getFullYear()
        );
      };

      if (
        checkMlContributor &&
        checkMlContributorDate &&
        isToday(new Date(checkMlContributorDate))
      ) {
        return checkMlContributor;
      }

      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          validateMagazineLuizaEmployees(
            cpf:  "${obj.cpf}",
          )
          {
            contributor
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              let isContributor = false;

              if (!response.error) {
                isContributor =
                  response.data.validateMagazineLuizaEmployees.contributor;
                localStorage.setItem("mlContributor", isContributor);
                localStorage.setItem(
                  "mlContributorDate",
                  new Date().toString()
                );
              }

              resolve(isContributor);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    uploadMedicalReport({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          uploadUserDocument(
            user_id: ${rootState.user.profile.id},
            document_base64: "${obj.document_base64}",
            original_filename: "${obj.original_filename}",
            upload_name: "${obj.upload_name || obj.original_filename}"
          )
          {
            id
            file
            name
          }
          }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    removeMedicalReports({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          removeUserLaudo(
            user_id: ${rootState.user.profile.id},
            medical_report_id: ${obj.id}
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    confirmEvent({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          confirmEvent(
            ${
              obj.opportunity_id
                ? ` opportunity_id: ${obj.opportunity_id} ,`
                : ""
            }
            user_id: ${rootState.user.profile.id},
            ${obj.event_id ? ` event_id: ${obj.event_id} ,` : ""}
            ${obj.address_id ? ` address_id: ${obj.address_id} ,` : ""}
            ${obj.room_id ? ` room_id: ${obj.room_id} ,` : ""}
            ${obj.schedule_id ? ` schedule_id: ${obj.schedule_id} ,` : ""}
            ${obj.chosen_date ? ` chosen_date: "${obj.chosen_date}" ,` : ""}
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    refuseEvent({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          refuseEvent(
            opportunity_id: ${obj.opportunity_id},
            user_id: ${rootState.user.profile.id},
            ${obj.event_id ? ` event_id: ${obj.event_id} ,` : ""}
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    cancelEventDecision({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        mutation {
          cancelEventDecision(
            opportunity_id: ${obj.opportunity_id},
            user_id: ${rootState.user.profile.id},
            ${obj.event_id ? ` event_id: ${obj.event_id} ,` : ""}
            ${obj.address_id ? ` address_id: ${obj.address_id} ,` : ""}
            ${obj.room_id ? ` room_id: ${obj.room_id} ,` : ""}
            ${obj.schedule_id ? ` schedule_id: ${obj.schedule_id} ,` : ""}
          ){
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    companyInternalRecruitment({ rootState }, obj = {}) {
      const params = new URLSearchParams();
      params.append(
        "query",
        `
        {
          companyInternalRecruitment(
            companyId: ${obj.companyId || rootState.companyId}
          )
          {
            loginType,
            specificDomains,
            domains
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const response = resp.data;

              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },

    async createSessionToken(){
      const apiSessionFetch = await fetch(
        `${Vue.prototype.OPPORTUNITIES_GRAPHQL_ENDPOINT}/sessions`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${process.env.VUE_APP_API_TOKEN}`,
          },
        }
      )
      const apiSession = await apiSessionFetch.json()

      // Salva a sessão criada no cookie
      Cookies.set('apiSession', JSON.stringify(apiSession), { expires: 1 })
    },

    questionUpdate({ rootState }, obj = {}) {
      const params = new URLSearchParams();

      const questions = obj.questions.map((q) => {
        let answer = "";

        if (Array.isArray(q.answer)) {
          answer = `${JSON.stringify(q.answer)}`;
        } else {
          answer = q.answer.toString();
        }

        return `{
          id: "${JSON.stringify(q.id)}",
          question: ${JSON.stringify(q.title)},
          answer: ${JSON.stringify(answer)},
        }`;
      });

      params.append(
        "query",
        `
        mutation {
          questionUpdate(
            questions_update_id: ${obj.questions_update_id}
            user_id: ${obj.user_id}
            opportunity_id: ${obj.opportunity_id}
            questions: [${questions}],
          )
          {
            success
          }
        }
      `
      );

      return new Promise((resolve, reject) => {
        axios
          .post(ENDPOINT, params, { headers: { Authorization: rootState.tkn } })
          .then(
            (resp) => {
              const questionUpdateResponse = resp.data;

              resolve(questionUpdateResponse);
            },
            (error) => {
              reject(error);
            }
          );
      });
    },
  },
};
